import React, { useEffect, useState, useRef } from "react";
import { useTheme } from "@mui/material";

import plaoaltowhite from "../../../assets/paloalto-white.svg";
import plaoalto from "../../../assets/paloalto.svg";
import newScanBg from "../../../assets/newScanBg.svg"
import newScanBgDark from "../../../assets/newScanBgDark.svg"
import ubuntu_dark from "../../../assets/ubuntu_dark.svg";
import Windows_light from "../../../assets/baseVersion/Windows_light.svg"
import Windows_dark from "../../../assets/baseVersion/Windows_dark.svg"
import ubuntu_light from "../../../assets/ubuntu_white.svg";
import redhat_light from "../../../assets/redhat_light.svg";
import redhat_dark from "../../../assets/redhat_dark.svg";
import fortinet_light from "../../../assets/fortinet.svg";
import fortinet_dark from "../../../assets/fortinet_scan_dark.svg";
import dell_logo from "../../../assets/baseVersion/dell-seeklogo 2.svg";
import syrotech_light from "../../../assets/syrotech_light.svg";
import syrotech_dark from "../../../assets/syrotech_dark.svg";
import "./NewScan.scss";
import {
  Box,
  Drawer,
  Tab,
  Tabs,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormControl,
  Divider,
  Typography,
} from "@mui/material";
import FileUploadComponent from "./fileUPload/FileUploadComponent";
import SSHComponent from "./ssh/SSHComponent";
import APIComponent from "./api/APIComponent";
import Vendors from "./Vendors";
import axiosInstance from "../../../axios/axios";
import CancelIcon from "@mui/icons-material/Cancel";
import UploadFile from "./fileUPload/UploadFile";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import useRolePermissions from "../../../shared/hooks/useRolePermissions";
import { ROLES_CONTENT_PROPS } from "../../../shared/constants/constant-data";
import ReusableSSHAPI from "./ReusableSSHAPI";

interface ScanType {
  type: string;
  label: string;
  description: string;
}

interface FrequencyOptions {
  frequency?: any;
  timeZone?: any;
  date?: any;
  timeOptions?: any;
  Days?: any;
}



const NewScan: React.FC = () => {
  const [frequencyOptions, setFrequencyOptions] = useState<FrequencyOptions>(
    {}
  );
  const [scanTypes, setScanTypes] = useState<ScanType[]>([]);
  const [type, setType] = useState<string>("");
  const [Upload_Display, setUpload_Display] = useState<boolean>(false);
  const [SSH_Display, setSSH_Display] = useState<boolean>(false);
  const [API_Display, setAPI_Display] = useState<boolean>(false);
  const [selectedType, setSelectedType] = useState<string>(""); // Holds selected scan type
  const [fileCount, setFileCount] = useState<number>(0); // Mock file count for disabled logic
  const [isVendorLoaded, setIsVendorLoaded] = useState<boolean>(true); // Moc
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false); // State for Drawer
  const [activeTab, setActiveTab] = useState<number>(0);
  const [isDirty, setIsDirty] = useState<boolean>(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);
  const [pendingTab, setPendingTab] = useState<number | null>(null);
  const [selectedVendor, setSelectedVendor] = useState<any>(null);
  const [vendorList, setVendorList] = useState<any[]>([]);
  const [allVendorList, setAllVendorList] = useState<any[]>([]); // Store all vendors
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const [carouselIndex, setCarouselIndex] = useState(0);
  const carouselTimer = useRef<NodeJS.Timeout | null>(null);
  const { hasPermissions } = useRolePermissions();
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  //const getImagePath = (name: string) => new URL(`../../../assets/${name.toLowerCase()}.svg`, import.meta.url).href;

  const getImagePath = (name: string) => {
    const normalizedName = name.trim().toLowerCase();

    if (normalizedName === "paloalto" || normalizedName === "palo alto") {
      return isDarkMode ? plaoaltowhite : plaoalto;
    }


    // Handle Ubuntu specifically
    if (normalizedName === "ubuntu") {
      return isDarkMode ? ubuntu_dark : ubuntu_light;
    }
    if (normalizedName === "microsoft" || normalizedName === "windows") {
      return isDarkMode ? Windows_dark : Windows_light;
    }
    if (normalizedName === "fortinet") {
      return isDarkMode ? fortinet_dark : fortinet_light;
    }

    if (normalizedName === "redhat") {
      return isDarkMode ? redhat_dark : redhat_light;
    }
    if (normalizedName === "dell") {
      return dell_logo;
    }
    if (normalizedName === "syrotech") {
      return isDarkMode ? syrotech_dark : syrotech_light;
    }

    // Handle other vendors
    const fileName = isDarkMode ? `${normalizedName}_dark` : normalizedName;
    return new URL(`../../../assets/${fileName}.svg`, import.meta.url).href;
  };


  //const [scheduleFrequency, setScheduleFrequency] = useState([]);

  const scanTypesArray: ScanType[] = [
    {
      type: "upload",
      label: "File Upload",
      description: "Upload configuration files to generate reports",
    },
    {
      type: "ssh",
      label: "SSH",
      description: "Fetch configuration from asset to scan",
    },
    {
      type: "api",
      label: "API",
      description: "Define your API details and start your scan",
    },
    {
      type: "winRM",
      label: "WinRM",
      description: "Enter your Windows credentials to enable WinRM access.",
    },
  ];

  const carouselScreens = [
    {
      id: "upload",
      type: "upload",
      content: (
        <>
          {/* <div style={{ fontWeight: '700', fontSize: '14px' }}><strong>File Upload scan</strong></div> */}
          <div style={{ marginLeft: '10px', fontSize: '14px', fontWeight: '500', fontStyle: 'medium', color: isDarkMode ? '#BDBDDA' : '#444067' }}>
            <div>
              1. Enter a scan name (optional)
            </div>
            <div>
              2. Upload one or multiple configuration files (XML, TXT) to scan single or
              multiple assets.
            </div>
            <div>3. Each file is treated as a separate asset.</div>
            <div>
              4. Once files are uploaded, click <strong>Submit</strong>.
            </div>
            <div>
              5. You’ll be redirected to the <strong>On-prem Scans</strong> for scan status.
            </div>


          </div>

        </>
      ),
    },
    {
      id: "ssh",
      type: "ssh",
      content: (
        <>
          {/* <div style={{ fontWeight: '700', fontSize: '14px' }}><strong>SSH scan</strong></div> */}
          <div style={{ marginLeft: '10px', fontSize: '14px', fontWeight: '500', fontStyle: 'medium', color: isDarkMode ? '#BDBDDA' : '#444067' }}>
            <div>
              1.<strong> Select Scan Type</strong> – Choose <strong>Single Asset</strong> or<strong> Multiple Assets</strong>.
            </div>
            <div>2. <strong>Enter Scan Name</strong> (optional).</div>
            <div>
              3.<strong> Add Asset Info</strong>
            </div>
            <div style={{ marginLeft: '20px' }}>
              a.<strong style={{}}> Single Asset:</strong> Enter IP/URL, select vendor, and optional
              custom port.
            </div>
            <div style={{ marginLeft: '20px' }}>
              b.<strong style={{}}> Multiple Assets:</strong> Download and fill the sample Excel,
              then upload it.
            </div>

            <div>
              4.<strong> Set Credentials:</strong> Use an existing one or create a new credential (Username + Password or Private Key). Save credential to
              setup recurring schedules.
            </div>
            <div>
              5. <strong>Schedule or Start Scan:</strong> Choose One-Time, Daily,
              Weekly, or Monthly with Start Time.
            </div>
            <div>
              6. Or click <strong>Scan Now</strong> to run immediately without schedule.
            </div>
            <div>
              7. Monitor progress under <strong>On-prem Scans</strong>.
            </div>
          </div>

        </>
      ),
    },
    {
      id: "api",
      type: "api",
      content: (
        <>
          {/* <div style={{ fontWeight: '700', fontSize: '14px' }} ><strong>API scan</strong></div> */}
          <div style={{ marginLeft: '10px', fontSize: '14px', fontWeight: '500', fontStyle: 'medium', color: isDarkMode ? '#BDBDDA' : '#444067' }}>
            <div>
              1. Enter an optional <strong>Scan Name.</strong>
            </div>
            <div>2. Provide the <strong>Asset IP/URL</strong>.</div>
            <div>3. Enable and enter a <strong>Custom Port</strong> if needed.</div>
            <div>4. Select the <strong>Asset Vendor</strong> and <strong>Asset Category</strong>.</div>
            <div>5. Choose or create a <strong>Credential</strong> using an <strong>API Token</strong>.</div>
            <div style={{ marginLeft: '20px' }}>
              a.To reuse a new credential, check the box and provide a <strong>Credential Name</strong>.
            </div>
            <div>
              6. Optionally, <strong>Schedule the scan</strong> (One Time, Daily, Weekly, Monthly) or
              click <strong>Scan Now</strong> to run it immediately.
            </div>
            <div>
              7. Once initiated, the scan status will appear in the <strong>On-prem Scans</strong>.
            </div>
          </div>

        </>
      ),
    },
    {
      id: "winRM",
      type: "winRM",
      content: (
        <>
          {/* <div style={{ fontWeight: '700', fontSize: '14px' }}><strong>SSH scan</strong></div> */}
          <div style={{ marginLeft: '10px', fontSize: '14px', fontWeight: '500', fontStyle: 'medium', color: isDarkMode ? '#BDBDDA' : '#444067' }}>
            <div>
              1.<strong> Select Scan Type</strong> – Choose <strong>Single WinRM</strong> or<strong> Multiple WinRM</strong>.
            </div>
            <div>2. <strong>Enter Scan Name</strong> (optional).</div>
            <div>
              3.<strong> Add WinRM Info</strong>
            </div>
            <div style={{ marginLeft: '20px' }}>
              a.<strong style={{}}> Single WinRM:</strong> Enter IP/URL, select vendor, and optional
              custom port.
            </div>
            <div style={{ marginLeft: '20px' }}>
              b.<strong style={{}}> Multiple WinRM:</strong> Download and fill the sample Excel,
              then upload it.
            </div>

            <div>
              4.<strong> Set Credentials:</strong> Use an existing one or create a new credential (Username + Password or Private Key). Save credential to
              setup recurring schedules.
            </div>
            <div>
              5. <strong>Schedule or Start Scan:</strong> Choose One-Time, Daily,
              Weekly, or Monthly with Start Time.
            </div>
            <div>
              6. Or click <strong>Scan Now</strong> to run immediately without schedule.
            </div>
            <div>
              7. Monitor progress under <strong>On-prem Scans</strong>.
            </div>
          </div>

        </>
      ),
    },
  ];
  const handleLoadVendors = (vendors: any[]) => {
    setVendorList(vendors);
    setAllVendorList(vendors); // Store all vendors for later reset
  };

  // Check if Microsoft/Windows vendor is available
  const hasMicrosoftVendor = allVendorList.some(
    (vendor: any) =>
      vendor.name.toLowerCase() === "microsoft" ||
      vendor.name.toLowerCase() === "windows"
  );

  // useEffect to mimic ngOnInit()
  useEffect(() => {
    const newScanTypes: ScanType[] = [];

    if (hasPermissions(ROLES_CONTENT_PROPS.UPLOAD_FILE)) {
      // Replace with actual condition
      newScanTypes.push(scanTypesArray[0]);
      setUpload_Display(true);
    }
    if (hasPermissions(ROLES_CONTENT_PROPS.SSH_CONNECTION)) {
      // Replace with actual condition
      newScanTypes.push(scanTypesArray[1]);
      setSSH_Display(true);
    }
    if (hasPermissions(ROLES_CONTENT_PROPS.API_CONNECTION)) {
      newScanTypes.push(scanTypesArray[2]);
      setAPI_Display(true);
    }
    // Only show WinRM option if Microsoft vendor is available
    if (hasPermissions(ROLES_CONTENT_PROPS.API_CONNECTION) && hasMicrosoftVendor) {
      newScanTypes.push(scanTypesArray[3]);
    }

    setScanTypes(newScanTypes);

    detectTimeZone();
    loadVendors();
    loadFrequency();
  }, [allVendorList]); // Re-run when vendor list is loaded

  // Dummy function to simulate time zone detection

  // Dummy function to simulate vendor loading
  const loadVendors = (): void => {
    // Your logic here
  };

  // Dummy function to simulate frequency loading
  const loadFrequency = async (): Promise<void> => {
    // Your logic here
    try {
      const response = await axiosInstance.get(
        `securityscan/schedule-frequency`
      );
      frequencyOptions.frequency = response.data.data.frequency;
      frequencyOptions.Days = response.data.data.weekly;
      frequencyOptions.timeOptions = timeOptions();
      frequencyOptions.timeZone =
        Intl.DateTimeFormat().resolvedOptions().timeZone;
      //const frequencyList = response.data || [];
      //setScheduleFrequency(frequencyList); // Assuming you have state for this
    } catch (error) {
      console.error("Error fetching schedule frequency: ", error);
    }
  };

  const detectTimeZone = (): string => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    console.log(timeZone);
    return timeZone;
  };

  const timeOptions = (formattedTime?: string): string[] => {
    let timeOptions: string[] = [];
    let startHour = 0;
    let startMinute = 0;
    let startSecond = 0;

    // Parse the formattedTime to determine the starting point
    if (formattedTime) {
      const timeParts = formattedTime.split(":");
      startHour = parseInt(timeParts[0], 10);
      startMinute = parseInt(timeParts[1], 10);
      if (timeParts.length > 2) {
        startSecond = parseInt(timeParts[2], 10);
      }
    }

    // Generate time options from the specified starting point
    for (let hour = startHour; hour < 24; hour++) {
      for (
        let minute = hour === startHour ? startMinute : 0;
        minute < 60;
        minute++
      ) {
        const period = hour < 12 ? "AM" : "PM";
        const adjustedHour = hour % 12 === 0 ? 12 : hour % 12;
        const formattedHour = String(adjustedHour).padStart(2, "0");
        const formattedMinute = String(minute).padStart(2, "0");
        const time = `${formattedHour}:${formattedMinute} ${period}`;
        timeOptions.push(time);
      }
    }

    // Append 12:00 AM at the end of the list if not included
    if (!timeOptions.includes("12:00 AM")) {
      timeOptions.push("12:00 AM");
    }

    return timeOptions;
  };

  // Handle radio button change
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selected = event.target.value;
    setSelectedType(selected);
    setSelectedVendor(null);
    // Reset vendorList to show all vendors when clicking radio buttons
    setVendorList(allVendorList);
    const idx = scanTypes.findIndex((scan) => scan.type === selected);
    setActiveTab(idx !== -1 ? idx : 0);

    if (selected === "ssh" || selected === "api" || selected === "upload" || selected === "winRM") {
      setDrawerOpen(true);
    } else {
      setDrawerOpen(false);
    }
  };

  // Handle keydown events to prevent default behavior (same as the Angular version)
  const handleKeyDown = (event: React.KeyboardEvent) => {
    event.stopPropagation();
    event.preventDefault();
  };
  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    if (isDirty) {
      setPendingTab(newValue);
      setConfirmDialogOpen(true);
    } else {
      setActiveTab(newValue);
    }
  };

  const handleFormDirty = (dirty: boolean) => {
    setIsDirty(dirty);
  };

  const handleDrawerClose = () => {
    if (isDirty) {
      setConfirmDialogOpen(true);
    } else {
      setDrawerOpen(false);
      setSelectedType("");
      setSelectedVendor(null); // <-- Reset vendor selection
      setVendorList(allVendorList); // <-- Reset to show all vendors
      setActiveTab(0);         // <-- Reset tab index
      setCarouselIndex(0);     // <-- Restart carousel to first screen
    }
  };

  const handleConfirmClose = (confirm: boolean) => {
    setConfirmDialogOpen(false);
    if (confirm) {
      setIsDirty(false);
      setDrawerOpen(false);
      setSelectedType("");
      setSelectedVendor(null); // <-- Reset vendor selection
      setVendorList(allVendorList); // <-- Reset to show all vendors
      if (pendingTab !== null) {
        setActiveTab(pendingTab);
        setPendingTab(null);
      }
    }
  };
  const handleVendorSelect = (vendor: any) => {
    setSelectedVendor(vendor);
    setVendorList([vendor]);
    setDrawerOpen(true);
    setActiveTab(0);
  };
  // Render only the corresponding tab based on selected type & vendor
  const renderSingleTab = () => {
    if (selectedVendor !== null) return renderMultipleTabs(selectedVendor);
    if (selectedType === "upload")
      return (
        <Tabs>
          {" "}
          <Tab
            label={
              <div style={{ display: "flex", alignItems: "center", }}>
                <UploadFileIcon />
                <span
                  style={{
                    fontWeight: "bolder",
                    fontSize: "18px",
                    marginLeft: 5,
                    textTransform: "none",
                  }}
                >
                  File Upload
                </span>
              </div>
            }
          />        </Tabs>
      );
    if (selectedType === "ssh")
      return (
        <Tabs>
          <Tab
            label={
              <span
                style={{
                  fontWeight: "bolder",

                  fontSize: "18px",
                }}
              >
                SSH
              </span>
            }
          />
        </Tabs>
      );
    if (selectedType === "api")
      return (
        <Tabs>
          {" "}
          <Tab
            label={
              <span
                style={{
                  fontWeight: "bolder",
                  fontSize: "18px",
                }}
              >
                API
              </span>
            }
          />        </Tabs>
      );
    if (selectedType === "winRM")
      return (
        <Tabs>
          {" "}
          <Tab
            label={
              <span
                style={{
                  fontWeight: "bolder",
                  fontSize: "18px",
                }}
              >
                winRM
              </span>
            }
          />        </Tabs>
      );
    return null;
  };

  // Render corresponding component based on selected type & vendor
  const renderTabContent = () => {
    if (selectedVendor !== null)
      return renderMultipleTabContent(selectedVendor);
    if (selectedType === "upload")
      return (
        <Box p={2}>
          <UploadFile onDirty={handleFormDirty} />
        </Box>
      );
    if (selectedType === "ssh")
      return (
        <SSHComponent
          onDirty={handleFormDirty}
          vendorList={vendorList}
          scheduleOptions={frequencyOptions}
        />
      );
    if (selectedType === "api")
      return (
        <APIComponent
          onDirty={handleFormDirty}
          vendorList={vendorList}
          scheduleOptions={frequencyOptions}
        />
      );
    if (selectedType === "winRM")
      return (
        <SSHComponent
          onDirty={handleFormDirty}
          vendorList={vendorList}
          scheduleOptions={frequencyOptions}
          component="winRM"
        />
      );
    return null;
  };
  // Helper to get available tabs for the selected vendor
  const getAvailableTabs = (vendor: any) => {
    const tabs = [];
    if (vendor.name.toLowerCase() == "microsoft") {
      tabs.push({
        type: "winRM",
        label: "winRM",
        content: (
          <SSHComponent
            onDirty={handleFormDirty}
            scheduleOptions={frequencyOptions}
            vendorList={vendorList}
            vendorSelected={vendor}
            component="winRM"
          />
        ),
      });
      return tabs;
    }
    // File Upload is not available for RedHat, Ubuntu, and Debian - only SSH is supported
    const vendorName = vendor.name.toLowerCase();
    const isLinuxVendor = vendorName === "redhat" || vendorName === "ubuntu" || vendorName === "debian" || vendorName === "huawei" || vendorName === "mikrotik" || vendorName === "edgecore";
    
    if (hasPermissions(ROLES_CONTENT_PROPS.UPLOAD_FILE) && !isLinuxVendor) {
      tabs.push({
        type: "upload",
        label: "File Upload",
        content: <UploadFile onDirty={handleFormDirty} vendorSelected={vendor} />,
      });
    }
    if (hasPermissions(ROLES_CONTENT_PROPS.SSH_CONNECTION)) {
      tabs.push({
        type: "ssh",
        label: "SSH",
        content: (
          <SSHComponent
            onDirty={handleFormDirty}
            scheduleOptions={frequencyOptions}
            vendorList={vendorList}
            vendorSelected={vendor}
            component="ssh"
          />
        ),
      });
    }
    if (
      hasPermissions(ROLES_CONTENT_PROPS.API_CONNECTION) &&
      vendor &&
      (vendor.name.toLowerCase() === "paloalto" ||
        vendor.name.toLowerCase() === "palo alto" || vendor.name.toLowerCase() === "sophos")
    ) {
      tabs.push({
        type: "api",
        label: "API",
        content: (
          <APIComponent
            onDirty={handleFormDirty}
            scheduleOptions={frequencyOptions}
            vendorList={vendorList}
            vendorSelected={vendor}
          />
        ),
      });
    }
    return tabs;
  };

  // Update renderMultipleTabs to use getAvailableTabs
  const renderMultipleTabs = (vendor: any) => {
    const tabs = getAvailableTabs(vendor);
    return (
      <div style={{ width: "100%" }}>
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignContent: "center", alignItems: 'center' }}>
          <img
            src={getImagePath(vendor.name)}
            alt={vendor.name}
            className="normal-state"
            style={{
              width: getImagePath(vendor.name).includes("cisco") ? 50 : 80,
              marginTop: 12,
              marginLeft: 12,
              height: 25,
            }}
          />
          <CancelIcon
            sx={{ mr: 3 }}
            style={{ color: "gray", cursor: "pointer" }}
            onClick={handleDrawerClose}
          />
        </div>
        <Tabs value={activeTab} onChange={handleTabChange}>
          {tabs.map((tab, idx) => (
            <Tab key={tab.label} sx={{ fontWeight: '700', textTransform: 'none' }} label={tab.label} />
          ))}
        </Tabs>
      </div>
    );
  };

  // Update renderMultipleTabContent to use getAvailableTabs
  const renderMultipleTabContent = (vendor: any) => {
    const tabs = getAvailableTabs(vendor);
    return (
      <Box sx={{ p: 2, overflowY: "hidden", height: "calc(100vh - 80px)" }} className="scroll">
        {tabs[activeTab]?.content}
      </Box>
    );
  };
  const getFilteredCarouselScreens = () => {
    if (!selectedType) return carouselScreens;
    return carouselScreens.filter(screen => screen.type === selectedType);
  };
  const filteredScreens = getFilteredCarouselScreens();
  const showCarousel = filteredScreens.length > 1;
  const currentIndex = showCarousel ? carouselIndex : 0;

  useEffect(() => {
    // Auto-advance carousel every 30 seconds only if showing all screens
    if (carouselTimer.current) clearTimeout(carouselTimer.current);
    if (showCarousel) {
      carouselTimer.current = setTimeout(() => {
        setCarouselIndex((prev) => (prev + 1) % filteredScreens.length);
      }, 30000);
    }
    return () => {
      if (carouselTimer.current) clearTimeout(carouselTimer.current);
    };
  }, [carouselIndex, selectedType, selectedVendor]); // <-- Add selectedVendor to dependencies

  // Helper to get carousel screens for vendor tabs
  const getVendorCarouselScreens = (vendor: any) => {
    const tabs = getAvailableTabs(vendor);
    return tabs.map(tab => {
      // Find matching carousel screen by type
      const screen = carouselScreens.find(s => s.type === tab.type);
      return {
        ...screen,
        label: tab.label,
        vendorName: vendor?.name,
      };
    });
  };

  return (
    <>
      <div className={isDarkMode ? "new-scan-dark new-scan" : "new-scan-light new-scan"}>
        <div className="new-scan-left">
          <div className="new-scan-dif">
            <h5 className={isDarkMode ? "dark-mode" : "light-mode"}>Start your Scan</h5>
            <p className={`sub-title ${isDarkMode ? "dark-mode" : "light-mode"}`}>
              Fast, Secure and User-friendly way to scan and Analyse your network security.
            </p>
            <div className="scan-divider" />
            {/* Carousel Start */}
            <div style={{ marginTop: 0, height: '300px', overflowY: "auto" }} className="scroll">
              {/* If vendor is selected, show carousel for vendor tabs */}
              {selectedVendor ? (
                (() => {
                  const vendorScreens = getVendorCarouselScreens(selectedVendor);
                  const showVendorCarousel = vendorScreens.length > 1;
                  const vendorCurrentIndex = showVendorCarousel ? activeTab : 0;
                  return (
                    <>
                      <div
                        id={vendorScreens[vendorCurrentIndex].id}
                        style={{
                          fontSize: 16,
                          color: isDarkMode ? "#BDBDDA" : "#444067",
                          minHeight: 60,
                          transition: "all 0.3s"
                        }}
                      >
                        {/* Show vendor name and tab label above content */}
                        <div style={{ fontWeight: 600, marginBottom: 8 }}>
                          <strong>{selectedVendor.name} {vendorScreens[vendorCurrentIndex].label} scan </strong>
                        </div>
                        {vendorScreens[vendorCurrentIndex].content}
                      </div>
                      {showVendorCarousel && (
                        <div style={{ display: "flex", justifyContent: "flex-start", marginTop: 16 }}>
                          {vendorScreens.map((screen, idx) => (
                            <span
                              key={screen.id}
                              onClick={() => setActiveTab(idx)}
                              style={{
                                display: "inline-block",
                                width: 10,
                                height: 10,
                                borderRadius: "50%",
                                margin: "0 6px",
                                background: vendorCurrentIndex === idx
                                  ? "#3A2ADA"
                                  : isDarkMode ? "#444067" : "#D6D6F2",
                                cursor: "pointer",
                                transition: "background 0.3s"
                              }}
                              id={`carousel-dot-${screen.id}`}
                            />
                          ))}
                        </div>
                      )}
                    </>
                  );
                })()
              ) : (
                <>
                  <div
                    id={filteredScreens[currentIndex].id}
                    style={{
                      fontSize: 16,
                      color: isDarkMode ? "#BDBDDA" : "#444067",
                      minHeight: 60,
                      transition: "all 0.3s"
                    }}
                  >
                    {/* Show scan type header if no vendor is selected */}
                    <div style={{ fontWeight: 600, marginBottom: 8 }}>
                      <strong>
                        {filteredScreens[currentIndex].type === "upload" && "File Upload Scan"}
                        {filteredScreens[currentIndex].type === "ssh" && "SSH Scan"}
                        {filteredScreens[currentIndex].type === "api" && "API Scan"}
                        {filteredScreens[currentIndex].type === "winRM" && "WinRM"}
                      </strong>
                    </div>
                    {filteredScreens[currentIndex].content}
                  </div>
                  {showCarousel && !selectedType && (
                    <div style={{ display: "flex", justifyContent: "flex-start", marginTop: 16 }}>
                      {filteredScreens.map((screen, idx) => (
                        <span
                          key={screen.id}
                          onClick={() => setCarouselIndex(idx)}
                          style={{
                            display: "inline-block",
                            width: 10,
                            height: 10,
                            borderRadius: "50%",
                            margin: "0 6px",
                            background: currentIndex === idx
                              ? "#3A2ADA"
                              : isDarkMode ? "#444067" : "#D6D6F2",
                            cursor: "pointer",
                            transition: "background 0.3s"
                          }}
                          id={`carousel-dot-${screen.id}`}
                        />
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>
            {/* Carousel End */}
          </div>
          <Box>
            <div style={{ display: "flex" }}>
              <img src={isDarkMode ? newScanBgDark : newScanBg} alt="New scan background" />
            </div>
          </Box>

        </div>
        <div className="new-scan-right">
          <div className="scan-type-section">
            <div>
              <Vendors
                onSelectVendor={handleVendorSelect}
                onLoadVendors={handleLoadVendors}
              />
              <div className="uploadtypelist">
                <p
                  style={{
                    fontSize: "13px",
                    fontWeight: 500,
                    lineHeight: "18px",
                    marginBottom: "8px",
                    color: isDarkMode ? "#BDBDDA" : "#444067",
                  }}
                >
                  Select the type you would like to proceed the scan?
                </p>
              </div>
              <div style={{ width: "100%" }}>
                <FormControl component="fieldset" style={{ width: "100%" }}>
                  <RadioGroup
                    value={selectedType}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  >
                    {scanTypes.map((scan, index) => (
                      <div
                        key={scan.type} // Ensure unique key
                        style={{
                          background: isDarkMode ? "#191C24" : "#ffffff",
                          boxShadow: "0 0 16px #0000000d",
                          borderRadius: "8px",
                          padding: "12px 14px",
                          marginBottom: "6px",
                          transition: "all 0.3s", // Smooth transition
                          width: "100%",
                          border:
                            hoveredIndex === index
                              ? "2px solid #3A2ADA"
                              : "2px solid transparent",
                        }}
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                      >
                        <FormControlLabel
                          value={scan.type}
                          control={<Radio />}
                          label={
                            <div>
                              <Typography
                                variant="body1"
                                fontWeight="bold"
                                style={{
                                  marginBottom: "2px",
                                  fontSize: "13px",
                                  lineHeight: "15px",
                                  color: isDarkMode ? "#BDBDDA" : "#110F27",
                                }}
                              >
                                {scan.label}
                              </Typography>
                              <Typography
                                variant="body2"
                                color="textSecondary"
                                style={{
                                  fontWeight: 400,
                                  fontSize: "11px",
                                  lineHeight: "13px",
                                  //color: "#888994",
                                }}
                              >
                                {scan.description}
                              </Typography>
                            </div>
                          }
                        />
                      </div>
                    ))}
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
          </div>
        </div>
        <Drawer anchor="right" open={drawerOpen} onClose={handleDrawerClose} PaperProps={{
          sx: {
            overflow: "hidden", // 🚫 disables scroll
          },
        }}>
          <Box sx={{
            width: 360,
            overflow: "hidden", // extra safety
          }}>
            {/* <Tabs value={activeTab} onChange={handleTabChange} centered>  
                            <Tab label="File Upload" />
                            <Tab label="SSH" />
                            {selectedVendor === "paloalto" && <Tab label="API" />}
                        </Tabs>
                        <Box p={2}>
                            {activeTab === 0 && <FileUploadComponent onDirty={handleFormDirty} />}
                            {activeTab === 1 && <SSHComponent onDirty={handleFormDirty} />}
                            {activeTab === 2 && <APIComponent onDirty={handleFormDirty} />}
                        </Box> */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {renderSingleTab()}
              {selectedVendor == null && (
                <CancelIcon
                  sx={{ mr: 3 }}
                  style={{ color: "gray", cursor: "pointer" }}
                  onClick={handleDrawerClose}
                />
              )}
            </div>
            <Divider variant="middle" />
            {renderTabContent()}
          </Box>
        </Drawer>
        <Dialog
          open={confirmDialogOpen}
          onClose={() => handleConfirmClose(false)}
          sx={{ height: "100%", width: "100%" }}
        >
          <DialogTitle sx={{ textAlign: "center" }}>Cancel Scan</DialogTitle>
          <DialogContent
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            This action will cancel the scan initiated.
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              onClick={() => handleConfirmClose(true)}
              variant="contained"
              fullWidth
            >
              Cancel Scan
            </Button>
            <Button
              onClick={() => handleConfirmClose(false)}
              variant="outlined"
              fullWidth
            >
              Go Back
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      {/* <img src={Image} alt='jsd' /> */}
    </>
  );
};
export default NewScan;
